import { Col, Grid, Row } from "@codat/orchard-ui";
import className from "classnames";
import * as React from "react";

import { CompanySummary } from "../../../Models";
import styles from "../CompanyDetailsModal.module.css";

interface SystemTabProps {
  company: CompanySummary;
}

const SystemTab: React.FC<SystemTabProps> = ({ company }) => {
  const mapPlatformVersions = () => {
    return company.platformVersion.map((version, index) => {
      if (index === company.platformVersion.length - 1) return version;
      if (company.platformVersion.length > 1) return `${version}, `;
      return version;
    });
  };

  const showPlatformVariant = (selectedCompany: CompanySummary) => {
    if (selectedCompany.platformVariant) {
      if (selectedCompany.connectorIntegration === "sage50")
        return selectedCompany.platformVariant.split(".").join(" ");
      return selectedCompany.platformVariant;
    }
  };

  const getVersionDetails = (company: CompanySummary) => {
    if (company.connectorIntegration === "qbwc") {
      return "N/A";
    } else if (company.hostName) {
      return (
        <Col className={styles.dataDirectory}>
          <p>{company.hostName}</p>
          <p>{company.connectorInstallDirectory}</p>
        </Col>
      );
    } else {
      return (
        <Col>
          <p className={className(styles.unknown, styles.endCol)}>Unknown</p>
        </Col>
      );
    }
  };

  return (
    <Grid className={styles.grid}>
      <Row className={styles.row}>
        <Col className={styles.lastConnectionCol} size={12}>
          <p>Username</p>
          <p>The username used for computer where installed</p>
        </Col>
        <Col className={styles.endCol} size={4}>
          <p className={company.installedUsername ? "" : styles.unknown}>
            {company.connectorIntegration === "qbwc"
              ? "N/A"
              : company.installedUsername || "Unknown"}
          </p>
        </Col>
      </Row>
      <Row className={styles.row}>
        <Col className={styles.lastConnectionCol}>
          <p>Computer Information</p>
          <p>The computer name and connector install directory</p>
        </Col>
        {getVersionDetails(company)}
      </Row>
      <Row className={styles.row}>
        <Col>
          <p>Directory path of linked data</p>
        </Col>
        <Col className={styles.dataDirectory}>
          <p className={company.odbcDataDirectory ? "" : styles.unknown}>
            {company.odbcDataDirectory || "Unknown"}
          </p>
        </Col>
      </Row>
      <Row className={styles.row} data-testid="platformInfo">
        <Col className={styles.lastConnectionCol}>
          <p>Platform Info</p>
          <p>Platform Variant and Version(s)</p>
        </Col>
        <Col className={styles.dataDirectory}>
          <p>{showPlatformVariant(company)}</p>
          <p>{mapPlatformVersions()}</p>
          {(!company.platformVariant || !company.platformVersion.length) && (
            <p className={styles.unknown}>Unknown</p>
          )}
        </Col>
      </Row>
    </Grid>
  );
};
export default SystemTab;
